import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=36c25ab6"
import script from "./barcode.vue?vue&type=script&lang=js"
export * from "./barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports